import React from 'react';

import Loader from 'react-loader-spinner';

import { Container } from './styles';

const LoaderComponent = () => {
  return (
    <Container>
      <Loader type="Oval" color="#2493EB" height={60} width={60} loading />
    </Container>
  );
};

export default LoaderComponent;
